module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1EULI"))).then(() => parcelRequire('l6KUI'));